import {EAudienceGroupState} from 'src/constants';

import {ETab} from './EditForm/TagsParametersAddresses/definitions';

export default {
  createClient: 'получателя',
  uploadList: 'список',
  editForm: {
    title: 'Данные получателя',
    dialogOpen: 'Между вами и получателем открыт диалог.',
    newDialogReady: 'У вас все готово, чтобы начать диалог',
    toDialog: 'В диалог',
    fields: {
      lastName: 'Фамилия',
      firstName: 'Имя',
      surName: 'Отчество',
      phone: 'Телефон',
      gender: 'Пол',
      birthDate: 'Дата рождения',
    },
    placeholders: {
      lastName: 'Не указана',
      firstName: 'Не указано',
      surName: 'Не указано',
      gender: 'Не указан',
      birthDate: 'Введите дату',
      phone: 'Введите номер',
    },
    tag: 'Тег',
    [ETab.RESTRICRICTIONS]: {
      head: 'Ограничения',
      blacklist: {
        title: 'Черный список',
        description:
          'Добавьте получателя в список исключений, чтобы он не получал рассылки, выполненные из личного кабинета',
        blockButton: 'В черный список',
        unblockButton: 'Исключить',
        blacklisted: 'Добавлен в черный список',
        confirmModal: {
          title: 'Добавить в черный список',
          description:
            'Внесенные в черный список получатели получают тег "Черный список" – это исключает их из рассылок, выполненных из вашего личного кабинета.',
        },
        unblockModal: {
          title: 'Удалить из черного списка',
          description:
            'Получатель снова сможет получать рассылки, выполненные из личного кабинета. Тег «Чёрный список» будет удалён.',
        },
        blacklistedSuccess: 'Получателю добавлен тег «Чёрный список»',
        unblacklistedSuccess: 'У получателя удалён тег «Чёрный список»',
      },
      whatsappBlock: {
        title: 'Блокировка в WhatsApp',
        description:
          'Блокировка получателя в ответ на спам и другие нежелательные действия в каналах WhatsApp. Применяется к тем получателям, которые написали входящее сообщение за последние 24 часа',
        blockButton: 'Заблокировать',
        blockButtonAddition: 'Блокировка',
        confirmModal: {
          title: 'Заблокировать получателя?',
          description:
            'После блокировки получатель не сможет отправлять и получать сообщения в этом канале. Ранее полученные сообщения сохранятся. ',
          blockSingle: 'Вы хотите заблокировать получателя в канале?',
          blockMulti: 'Выберите каналы, в которых вы хотите заблокировать получателя.',
          emptyDescription:
            'Нельзя заблокировать получателя, он не писал входящих сообщений за последние 24 часа.',
        },
        unblockModal: {
          title: 'Разблокировать получателя?',
          descriptionSingle: 'Разблокировать получателя в канале',
          description: 'Выберите каналы, в которых нужно разблокировать получателя',
        },
        blocked: 'Заблокирован в WhatsApp',
        unblockButton: 'Разблокировать',
        blockedInChannels: 'Заблокирован в следующих каналах:',
        unblockSuccess: 'Получатель разблокирован в канале {{name}}',
        unblockError: 'Не удалось разблокировать получателя в канале {{name}}',
        blockSuccess: 'Получатель заблокирован в канале {{name}}',
        blockError: 'Не удалось заблокировать получателя в канале {{name}}',
      },
      unsubscribe: {
        title: 'Отписка от рассылки в WhatsApp',
        description: 'Получатель выразил желание не получать рассылки в каналах WhatsApp',
        unsubscribeButton: 'Отписать от рассылок',
        subscribeButton: 'Восстановить подписку',
        addUnsubscribedSubject: 'Отписать',
        userUnsubscribed: 'У получателя есть каналы, от которых он отписался',
        unsubscribedSubjects: 'Отписан в каналах:',
        successSubscribe: 'Восстановлена подписка получателя в {{subjects}}',
        errorSubscribe: 'Не удалось восстановить подписку получателя в {{subjects}}',
        successUnsubscribe: 'Получатель отписан от рассылок в {{subjects}}',
        errorUnsubscribe: 'Не удалось отписать получателя от рассылок в {{subjects}}',
        subjects_one: 'канале {{subjects}}',
        subjects_few: 'каналах {{subjects}}',
        subjects_many: 'каналах {{subjects}}',
        subscribeModal: {
          title: 'Восстановить подписку получателю',
          description: 'Выберите каналы, в которых получатель снова будет получать рассылки',
          descriptionSingle: 'Получатель снова будет получать рассылки в канале',
          submitButton: 'Восстановить',
        },
        unsubscribeModal: {
          title: 'Отписать получателя от рассылок',
          description:
            'После отписки получатель не будет получать рассылки в выбранных каналах.\n\n' +
            'Выберите каналы, в которых нужно отписать получателя от рассылок.',
          descriptionSingle: 'После отписки получатель не будет получать рассылки в канале',
          submitButton: 'Отписать',
        },
      },
      errors: {
        selectSubjects: 'Выберите каналы',
      },
      hide: 'Свернуть все',
      showAll: 'Развернуть еще {{count}}',
    },
    [ETab.TAGS]: {
      head: 'Теги получателя',
      content: {
        title: 'Теги получателя',
        action: 'Присвоить тег',
        notification: 'Теги успешно добавлены',
      },
      empty: {
        title: 'У этого получателя пока нет тегов',
        text: 'Вы можете добавить теги сразу или позже, когда у вас появится больше информации о получателе',
        action: 'Присвоить тег',
      },
    },
    [ETab.PARAMETERS]: {
      head: 'Переменные',
      content: {
        title: 'Пользовательские переменные',
        description:
          'Такие переменные добавляются вручную или загружаются вместе со списком получателей. Их можно использовать в рассылках, диалогах и сценариях. Переменные можно добавлять, изменять и удалять.',
        action: 'Присвоить переменную',
        nameLabel: 'Переменная',
        valueLabel: 'Значение',
        showAll: 'Показать все',
        hideAll: 'Свернуть',
      },
      system: {
        title: 'Системные переменные',
        description:
          'Pulse автоматически получает эти данные о получателе из подключенных каналов. Это может быть идентификатор пользователя в канале, username, отображаемое имя и другие данные. Системные переменные доступны только для чтения — изменить или удалить их нельзя.',
        nameLabel: 'Переменная',
        valueLabel: 'Значение',
        groupSeparator: 'и',
      },
    },
  },
  editGroupForm: {
    title: 'Добавьте список',
    subtitle: `Загрузите новый список получателей и добавьте признаки.\nНа загрузку списка понадобится какое-то время`,
    pendingHint: `<0>Пожалуйста, не покидайте страницу.</0>\nЕсли вы уйдете со страницы, прогресс не сохранится`,
    fileButton: '.xlsx',
    anotherFileButton: 'Загрузить другой список',
    tag: 'тег',
    tags: 'Теги',
    chooseTag: 'Выбрать признаки',
    chooseFromTagTree: 'Дерево тегов',
    tagIds: 'Присвойте теги для вашего списка',
    tagIdsHint: 'Укажите теги, которые будут применены для выбранного',
    variable: 'переменную',
    variables: 'Переменные получателей',
    variableIds: 'Присвойте переменные получателям списка',
    variableIdsHint: 'Укажите для каждого столбца название переменной',
    chooseVariable: 'Выберите переменную',
    editTitle: 'Добавьте признаки списка',
    uploadTitle: 'Добавляем список в базу',
    uploadSubtitle: `Загружаем и обновляем вашу аудиторию, это займет какое-то время
    <0>Вы можете покинуть страницу</0> - процесс будет выполняться.
    Актуальный статус загрузки можно узнать на <1>этой странице</1>`,
    errorLoadingFile:
      'Загрузка списка аудитории была прервана. Список получателей базы {{fileName}} не был загружен.',
    flowParticipation: 'Участие в сценариях',
    flowHint: 'Запустить для получателей этого списка сценарий со стартом по внешнему триггеру',
    selectFlow: 'Выберите один или несколько сценариев',
  },
  editGroupFormModal: {
    title: 'Загрузить документ',
    subtitle:
      'К уже выбранной аудитории получателей вы можете добавить новый список и задать ему тег. На загрузку списка новых получателей потребуется какое-то время',
    fileButton: 'Прикрепить файл',
    anotherFileButton: 'Прикрепить другой файл',
  },
  pickAudienceForm: {
    title: 'Куда определить выбранную аудиторию?',
    subtitle: {
      tagsChosen: 'Аудиторию с этими тегами нужно:',
      tagsNotChosen:
        'Вы загрузили список получателей и не назначили этому списку теги. Мы присвоили этому списку тег с названием вашего файла (вы найдете его в категории “Списки рассылки”). Что дальше сделать с этой аудиторией?',
    },
    whichGroup: 'В какую группу отнести аудиторию?',
    includeToBroadcast: 'Добавить в рассылку',
    excludeFromBroadcast: 'Исключить из рассылки',
    button: {
      continue: 'Продолжить',
      back: 'Назад',
    },
    group: 'Группа',
    tagWarning: {
      [EAudienceGroupState.excluded]:
        'Аудитория с таким тегом уже включена в рассылку, одновременно исключить ее из рассылки нельзя.',
      [EAudienceGroupState.included]:
        'Аудитория с таким тегом уже исключена из рассылки, одновременно включить ее в рассылку нельзя',
    },
  },
  modal: {
    uploadingTitle: 'Прогресс загрузки получателей',
    resultTitle: 'Результат загрузки получателей',
    successInfoWithFile_one:
      'Из файла {{fileName}} в базу <b>загружен {{successCount}} получатель</b> из {{totalCount}}, или <b>{{percent}}%</b>',
    successInfoWithFile_few:
      'Из файла {{fileName}} в базу <b>загружено {{successCount}} получателя</b> из {{totalCount}}, или <b>{{percent}}%</b>',
    successInfoWithFile_many:
      'Из файла {{fileName}} в базу <b>загружено {{successCount}} получателей</b> из {{totalCount}}, или <b>{{percent}}%</b>',
    successInfo_one:
      'В базу <b>загружен {{successCount}} получатель</b> из {{totalCount}}, или <b>{{percent}}%</b>',
    successInfo_few:
      'В базу <b>загружено {{successCount}} получателя</b> из {{totalCount}}, или <b>{{percent}}%</b>',
    successInfo_many:
      'В базу <b>загружено {{successCount}} получателей</b> из {{totalCount}}, или <b>{{percent}}%</b>',
    errorInfo_one: '. Не загружен {{errorCount}} получатель. <0><b>Скачать список</b></0>',
    errorInfo_few: '. Не загружены {{errorCount}} получателя. <0><b>Скачать список</b></0>',
    errorInfo_many: '. Не загружены {{errorCount}} получателей. <0><b>Скачать список</b></0>',
  },
  error: {
    atLeastOnePhone: 'Выберите колонку с номером телефона',
    atLeastOnePhoneMessage:
      'Чтобы вы могли работать с этим списком получателей, один из столбцов списка должен иметь заголовок "Телефон" и содержать номера телефонов',
    failedToLoadParameters: 'Произошла ошибка при загрузке переменных получателя',
    failedToLoadTags: 'Произошла ошибка при загрузке тегов получателя',
    failedToLoadAddresses: 'Произошла ошибка при загрузке идентификаторов получателя',
  },
  list: {
    searchPlaceholder: 'Быстрый поиск по ФИО, телефону или идентификатору',
    name: 'ФИО',
    emptyName: 'Имя не задано',
    phone: 'Идентификатор',
    addButton: 'в базу',
    addClient: 'Добавить получателя',
    addList: 'Добавить список',
  },
  notification: {
    emptyFile: 'Файл пуст, пожалуйста, загрузите другой',
  },
  dialog: {
    remove: {
      title: 'Правда хотите удалить получателя?',
      body: 'Мы безвозвратно потеряем его и всю информацию о нем',
    },
  },
  empty: {
    title: 'Здесь пока никого нет',
    subtitle:
      'Пока у вас никого нет в базе получателей. Вы можете добавить одного получателя или сразу целый список',
  },
  noDataWithFilters: {
    title: ':(',
    text: 'Мы не нашли получателя с таким номером телефона или идентификатором',
    hint: 'Проверьте, возможно данные введены неверно',
    button: 'Назад к списку',
  },
  filters: {
    selectTags: 'Выбрать теги',
    recipientTags: 'Теги получателя',
    recipientRestrictions: 'Ограничения получателя',
    whatsAppBlock: 'Блокировка в WhatsApp',
    blacklist: 'Черный список',
    parameters: 'Переменные',
    unsubscribed: 'Отписка от рассылки в WhatsApp',
  },
};
